import httpClient from 'api/httpClient';
import { EnterpriseDataRoomSuggestedActions } from 'models/EnterpriseSuggestedActions';
import { PaginatedData } from 'models/PaginatedData';
import { SuggestionPage } from 'models/SuggestedActions';
import { Params } from 'react-router-dom';
import utils, { getHasElementsInArray } from 'utils';

const getArrayParam = (key: string, value?: string[]) =>
  getHasElementsInArray(value)
    ? { [key]: utils.mapArrayToParams(value) }
    : {};

function getEnterpriseSuggestedActions(
  enterpriseId: string,
  hasSuggestedActions?: boolean,
  actionType?: string[],
  dealRoomIds?: string[],
  params?: Params,
) {
  return httpClient.get<PaginatedData<EnterpriseDataRoomSuggestedActions>>(
    `enterprises/${enterpriseId}/suggested-actions/data-rooms`,
    {
      params: {
        hasSuggestedActions,
        ...getArrayParam('actionType', actionType),
        ...getArrayParam('dealRoomIds', dealRoomIds),
        ...params,
      },
    },
  );
}

function muteSuggestedAction(
  dataRoomId: string,
  actionType: string,
  suggestionPage: SuggestionPage,
  duration?: number,
) {
  return httpClient.post(
    `data-rooms/${dataRoomId}/suggested-actions/${actionType}/mute`,
    { duration, suggestionPage },
  );
}

function actionedSuggestedAction(
  dataRoomId: string,
  data: {
    suggestionName: string;
    suggestionAction: string;
    suggestionPage?: SuggestionPage;
  },
) {
  return httpClient.post(
    `data-rooms/${dataRoomId}/suggested-actions/action`,
    data,
  );
}

export default {
  getEnterpriseSuggestedActions,
  muteSuggestedAction,
  actionedSuggestedAction,
};
